import { IconButton, SvgIcon, Tooltip } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

const RemoveButton = ({ onClick, tooltip, color, ...props }) => {
  return (
    <Tooltip title={tooltip} arrow>
      <IconButton onClick={onClick} {...props}>
        <SvgIcon sx={{ fontSize: 18 }}>
          <CloseIcon sx={color ? { color: color } : {}} />
        </SvgIcon>
      </IconButton>
    </Tooltip>
  );
};

export default RemoveButton;
